import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { HistoryManager } from "../../../Managers/HistoryManager";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { SearchClientManager } from "../SearchClientManager";

export class PacSearchClientManager extends SearchClientManager {
	constructor(options) {
		super(options);
	}
	addHistory(event) {
		var _this = this;

		if (!event.fromHistory && !event.noHistory && this.isCurrent()) {

			event.searchParams = this.getSearchParams();

			var newEvent = $.extend(true, {}, event);
			newEvent.currentPage = _this.currentPage;

			HistoryManager.add(_this.getURLParamsForHash(event), function (event, hash) {
				if (event.oldPage !== undefined) {
					_this.currentPage = event.oldPage;
				}
				_this.currentPage = newEvent.currentPage;
				if (_this.isCurrent() == false) {
					LS2PacSearchDatabaseManager.setCurrentDatabaseKey(event.databaseKey);
				}
				TLCEventManager.fireEvent(_this.searchEvent, event);
			}, newEvent);
		}
	}
}
